export default "__VITE_ASSET__Dj8uqPzb__"